module.exports = __webpack_public_path__ + "images/icons_v2/petrol-stations-cb5bb4af.svg";